// Libraries
import React from "react";
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

// Local Libraries
import { capitalizeFirstLetter, permissionFinder } from '../../helpers/util'
import phrasebookLoad from "../../i18n";
import { gisRoutes } from "../../routes/routes";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';

// Redux
import { serviceNumberTypeActions } from 'actions';

// Components
import { InfoBox } from "../../components/SkyFramework/Boxes/InfoBox";
import { InfoCounters } from "../../components/SkyFramework/Boxes/InfoCounters";
import { ContentBox } from "../../components/SkyFramework/Boxes/ContentBox";
import MapChart from "../../components/SkyFramework/Map/MapChart";
import { TableDashboard } from "../../components/SkyFramework/Tables/TableDashboard";

// Constants
const phrasebook = phrasebookLoad()



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedUser: props.authUser,
      coordinates: undefined,
    }
  }

  componentDidMount() {
    this.props.dispatch(serviceNumberTypeActions.getAllCoverageCoordinates());
  }

  componentDidUpdate(prevProps) {
    if (this.props.coordinates && prevProps && prevProps.coordinates !== this.props.coordinates) {
      this.setState({ coordinates: this.props.coordinates.data });
    }
  }




  InfoCounters = () => {
    var counters = [];
    // What counters can we have?
    // customers (just pccw)
    // accounts (per customer or total)
    // notifications (new)
    // orders (total)
    if (this.state.customers) {
      counters.push({ title: phrasebook.headerlinks.customers, count: this.state.customers.count, info: 'Total customers on GIS application', location: gisRoutes.account.customer.list });
    }
    if (this.state.accounts) {
      counters.push({ title: phrasebook.headerlinks.accounts, count: this.state.accounts.count, info: 'Total accounts on GIS application', location: gisRoutes.account.account.list });
    }
    if (this.state.orders) {
      counters.push({ title: phrasebook.headerlinks.orders, count: this.state.orders.count, info: 'Total orders', location: gisRoutes.management.order.list });
    }
    if (this.state.notifications) {
      counters.push({ title: phrasebook.notifications.new_notifications, count: this.state.notifications.count, info: 'New Notifications', location: gisRoutes.notification.notification.list });
    }


    if (counters.length > 0) return (<InfoCounters counters={counters} />)
    else return null;
  }



  render = () => {
    return <>
      <ContentBox
        intro={capitalizeFirstLetter(phrasebook.common.welcome)}
        text1={phrasebook.portal_view.visitors}
      />
      {this.state.coordinates && !token.loggedAccountType() ?
        <div>
          <h2>Coverage worldwide</h2>
          <Carousel swipeable={false} autoPlay={true} infiniteLoop={true} interval={4000} showArrows={false} showThumbs={false}>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.asia} projectionConfig={{
                rotate: [-100, -10, 0],
                scale: 400
              }} region={['Europe', 'Asia', 'Oceania']} />
              <p className="legend">Asia</p>
            </div>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.europe} projectionConfig={{
                rotate: [-15, -52.0, 10],
                scale: 1000
              }} region={['Europe', 'Asia']} />
              <p className="legend">Europe</p>
            </div>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.africa} projectionConfig={{
                rotate: [-15, 0, 0],
                scale: 500
              }} region={['Africa', 'Europe', 'Asia']} />
              <p className="legend">Africa</p>
            </div>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.northamerica} projectionConfig={{
                rotate: [100, -40, 0],
                scale: 900
              }} region={['Americas']} />
              <p className="legend">North America</p>
            </div>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.northamerica} projectionConfig={{
                rotate: [75, -10, 0],
                scale: 1800
              }} region={['Americas']} />
              <p className="legend">Central America</p>
            </div>
            <div>
              <MapChart width={1000} height={800} covCoordinates={this.state.coordinates.southamerica} projectionConfig={{
                rotate: [58, 20, 0],
                scale: 500
              }} region={['Americas']} />
              <p className="legend">South America</p>
            </div>


          </Carousel>
        </div>



        : null}

      {token.loggedAccountType() && token.loggedAccountType() == 400 ? <div className="container pt-0">
        {" "}
        <h3>
          {" "}
          {capitalizeFirstLetter(phrasebook.common.welcome)}{" "}
          {this.state.loggedUser.username}
        </h3>
        <h4>
          {phrasebook.profile.account_type}:{" "}
          {
            phrasebook.accounts[
            accountTypesConstants[this.state.loggedUser.account_type_id]
            ]
          }
        </h4>
      </div> : null}
      {/* projectionConfig
region */}


      {/* {this.InfoCounters()}</div> */}

    </>
  }
}

function mapStateToProps(state) {
  const { servicenumbertype, authentication } = state;
  const { authUser } = authentication;
  return {
    authUser,
    coordinates: servicenumbertype.servicenumbertypecoveragecoordinates
  };
}

const dashboard = connect(mapStateToProps)(Dashboard);
export default (dashboard);
